import { render, staticRenderFns } from "./NewCurrentTargetDialog.vue?vue&type=template&id=426f4ec1&scoped=true"
import script from "./NewCurrentTargetDialog.vue?vue&type=script&lang=js"
export * from "./NewCurrentTargetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426f4ec1",
  null
  
)

export default component.exports